module.exports = __webpack_public_path__ + "slider-3.jpg?2f51be7bfa28176ccc41f8401d99c051";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/slider-3.jpg
// module id = 304
// module chunks = 0